import React from "react";
import moment from "moment";
import "rc-tooltip/assets/bootstrap.css";
import Utils from "../../../../lib/utils";

import { ApplyNow, AppliedJobMessage } from "./style.ts";

const SecondarySection = ({ handleApply, history, job, user, applied }) => {
  const apply = () => {
    if (Utils.isSignedIn()) {
      handleApply();
    } else {
      history.push(`/login`);
    }
  };

  const emailJob = () => {}; // @TODO email job

  const getExpirationDate = () => {
    const date = new Date(job.created_at);
    const newdate = new Date(date);
    newdate.setDate(newdate.getDate() + 30);
    return moment(newdate.toISOString()).format("MM/DD/YY");
  };

  return (
    <>
      {Utils.isApplicant(user) && (Utils.hasApplied(user, job) || applied) ? (
        <AppliedJobMessage>You have applied for this job </AppliedJobMessage>
      ) : (
        !Utils.isEmployer(user) && (
          <ApplyNow type="button" onClick={apply} className="hidden-xs">
            Apply now
          </ApplyNow>
        )
      )}

      {Utils.isEmployer(user) && (
        <div className="hidden-xs">
          {false && job.owner_id === user.id && <i className="fa fa-trash" />}
          Expires {getExpirationDate()}
        </div>
      )}
    </>
  );
};

export default SecondarySection;
